export class UnifiedRestorePlan {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "providerAccountId",
            "baseName": "providerAccountId",
            "type": "string",
            "format": ""
        },
        {
            "name": "directorySnapshotId",
            "baseName": "directorySnapshotId",
            "type": "string",
            "format": ""
        },
        {
            "name": "directorySnapshotPointInTime",
            "baseName": "directorySnapshotPointInTime",
            "type": "Date",
            "format": "date-time"
        },
        {
            "name": "latestSnapshotPointInTime",
            "baseName": "latestSnapshotPointInTime",
            "type": "Date",
            "format": "date-time"
        },
        {
            "name": "vaultId",
            "baseName": "vaultId",
            "type": "string",
            "format": ""
        },
        {
            "name": "entities",
            "baseName": "entities",
            "type": "Array<UnifiedRestoreEntity>",
            "format": ""
        },
        {
            "name": "microsoft365Snapshots",
            "baseName": "microsoft365Snapshots",
            "type": "Array<UnifiedRestoreMicrosoft365Snapshot>",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return UnifiedRestorePlan.attributeTypeMap;
    }
    constructor() {
    }
}
